import React, { type HTMLAttributes, type PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import containerFluid from '../shared/styles';

const Container = styled.div`
    ${containerFluid}
    padding: 0 ${Spacing16};
`;

export default function ContainerFluid(props: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
    return <Container {...props} />;
}
